'use strict';
import {ORGANIZATION_COLLECTION} from '../../organizations/domain/config';

export const USER_PREFERENCE_CLASS_NAME = 'UserPreferenceDomain';
export const USER_PREFERENCE_COLLECTION = 'user-preferences';

export function UserPreferenceDomainProvider() {
  return {
    $get: [
      'FirebaseUtil',
      'AbstractDomainClass',
      function (
        FirebaseUtil,
        AbstractDomainClass,
      ) {
        function UserPreferenceDomain(data) {
          AbstractDomainClass.call(this, UserPreferenceDomain, data);
        }

        AbstractDomainClass.__inheritFrom(UserPreferenceDomain, USER_PREFERENCE_CLASS_NAME, USER_PREFERENCE_COLLECTION);

        UserPreferenceDomain.$constraints.addConstraints({
          lastOrganization: {type: 'DomainLink', domainType: 'OrganizationDomain', nullable: true},
          notifications: {type: 'JSON', stringify: true, nullable: true},
        });

        // more methods go here;
        UserPreferenceDomain.setLastOrgId = function (userId, orgId) {
          return !userId
            ? Promise.resolve(null)
            : FirebaseUtil.firebaseRef([
              USER_PREFERENCE_COLLECTION,
              userId,
              'lastOrganization'
            ].join('/')).set(orgId ? {id: orgId, collection: ORGANIZATION_COLLECTION} : null);
        };

        /**
         *
         * @param {String} userId
         * @return {Promise.<?String>}
         */
        UserPreferenceDomain.getLastOrgId = function (userId) {
          return !userId
            ? Promise.resolve(null)
            : FirebaseUtil.firebaseRef([
              USER_PREFERENCE_COLLECTION,
              userId,
              'lastOrganization',
              'id',
            ].join('/'))
              .once('value')
              .then(ss => ss.exists() ? ss.val() : null);
        };

        return UserPreferenceDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/auth/domain/UserPreferenceDomain.js